var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"ImageMap"},[_c('div',{staticClass:"image-area",style:({ '--image': ("url(" + (_vm.myMeta[0].image) + ")"), '--ratio': _vm.ratio })},_vm._l((_vm.imageMapButtons),function(btn){return _c('A',{key:("btn_" + (btn.id)),staticClass:"button",style:({
				'--left': btn.area.split(',')[0] / _vm.maxWidth,
				'--top': btn.area.split(',')[1] / _vm.maxHeight,
				'--width': btn.area.split(',')[2] / _vm.maxWidth,
				'--height': btn.area.split(',')[3] / _vm.maxHeight
			}),on:{"click":function($event){!_vm.disabled && _vm.onClickButton(btn)}}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }